import { createFileRoute } from '@tanstack/react-router'

import { useShellClient } from '@/components/clients/shell-client'
import { DocumentsPanel } from '@/components/documents/documents-panel'
import { documentsShape } from '@/components/documents/documents-search-schema'
import { Frame } from '@/components/frame'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/clients/$clientId/documents')({
  validateSearch: (search: Record<string, unknown>) => readSearch(documentsShape, search),
  component: ClientDocumentsPage,
})

function ClientDocumentsPage() {
  const client = useShellClient()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Frame>
      <DocumentsPanel
        clientId={client.id}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: (current) => ({ ...current, ...next }) })
        }}
      />
    </Frame>
  )
}
